




















































































import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import FscCard from "@/components/Card/FscCard.vue";
import Question from "@/views/LMSExamQuestions/QuestionTutor/QuestionCard/Question.vue";
import QuestionList from "@/views/LMSExamQuestions/QuestionTutor/QuestionCard/QuestionList.vue";
import ActionButton from "@/components/Button/ActionButton.vue";
import AbortButton from "@/components/Button/AbortButton.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import SearchBar from "@/views/LMSExamQuestions/QuestionTutor/QuestionCard/SearchBar.vue";
import QuestionExplanation from "@/views/LMSExamQuestions/QuestionTutor/QuestionCard/QuestionExplanation.vue";
import MyLastSearchTerms from "@/views/LMSExamQuestions/QuestionTutor/QuestionCard/MyLastSearchTerms.vue";
import MyLastQuestions from "@/views/LMSExamQuestions/QuestionTutor/QuestionCard/MyLastQuestions.vue";
import LMSDashboardLink from "@/views/LMSDashboard/LMSDashboardLink.vue";
import QuestionCategories from "@/views/LMSExamQuestions/ThemeLoop/QuestionCategories.vue";
import YoutubeLogo from "@/assets/Icon_Videolink_coloured_blue.svg";

@Component({
  components: {
    LMSDashboardLink,
    MyLastQuestions,
    MyLastSearchTerms,
    QuestionExplanation,
    SearchBar,
    SaveButton,
    AbortButton,
    ActionButton,
    Question,
    QuestionList,
    FscCard,
    QuestionCategories,
  },
})
export default class ThemeLoop extends mixins() {
  public name = "ThemeLoop";
  public YoutubeLogo = YoutubeLogo;

  public anyCategoryExpanded: boolean | null = false;

  public setAnyCategoryExpanded(state: boolean, submittedQuestionTerm: string) {
    this.anyCategoryExpanded = state;
    this.selectedQuestion = null;
    this.submittedQuestionTerm = submittedQuestionTerm;
    this.$nextTick(() => {
      (this.$refs.QuestionList as QuestionList).searchWithToken(this.submittedQuestionTerm, false);
    });
  }

  public selectedQuestion: any = null;
  public questionExplanationClosed: boolean | null = false;
  public submittedQuestionTerm: string | null = null;

  public onSubcategoryClick(submittedQuestionTerm: string): void {
    this.selectedQuestion = null;
    this.submittedQuestionTerm = submittedQuestionTerm;

    this.$nextTick(() => {
      (this.$refs.QuestionList as QuestionList).searchWithToken(this.submittedQuestionTerm, false);
    });
  }

  public onQuestionSelected(selectedQuestion: any): void {
    this.selectedQuestion = selectedQuestion;
    // Wait for Vue to render the selected question
    this.$nextTick(() => {
      (this.$refs.Question as Question).setSelected(this.selectedQuestion);
      (this.$refs.QuestionExplanation as QuestionExplanation).setSelectedQuestionOfficialNumber(this.selectedQuestion.officialNumber);
    });
  }

  protected actualQuery: any = {};

  public setActualQuery(query: any): void {
    this.actualQuery = query;
  }

  public closeQuestionPreviewAndEdit(): void {
    this.questionExplanationClosed = true;
    this.selectedQuestion = null;
    this.$nextTick(() => {
      if (this.submittedQuestionTerm) {
        (this.$refs.QuestionList as QuestionList).setToken(this.submittedQuestionTerm, this.actualQuery);
      }
    });
  }
}
